<div class="contentModal">
  <div class="tituloModal">
    <span>Compartir recetas</span>
    <mat-icon class="buttonClose" [mat-dialog-close]="false">close</mat-icon>
  </div>

  <!-- Estado: Enviado exitosamente -->
  <div *ngIf="enviado" class="textModal enviado-container">
    <div class="enviado-content">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <p>
        {{ data.recetas.length === 1 ? "Receta enviada" : "Recetas enviadas" }}
        correctamente por {{ method === "whatsapp" ? "WhatsApp" : "email" }}
      </p>
    </div>
  </div>

  <!-- Formulario de envío -->
  <div *ngIf="!enviado" class="bodyModal">
    <p class="info-text">
      Se {{ data.recetas.length === 1 ? "enviará 1 receta" : "enviarán " + data.recetas.length + " recetas" }}
    </p>

    <mat-radio-group [(ngModel)]="method" (ngModelChange)="onMethodChange()" class="method-group">
      <mat-radio-button value="whatsapp" *ngIf="canales.whatsapp">
        <mat-icon class="method-icon">phone</mat-icon>
        WhatsApp
      </mat-radio-button>
      <mat-radio-button value="email" *ngIf="canales.email">
        <mat-icon class="method-icon">email</mat-icon>
        Email
      </mat-radio-button>
    </mat-radio-group>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ destinationLabel }}</mat-label>
      <input
        matInput
        [value]="destination"
        readonly
      />
      <mat-icon matSuffix>{{ method === "whatsapp" ? "phone" : "email" }}</mat-icon>
    </mat-form-field>

    <div *ngIf="error" class="error-message">
      <mat-icon>error</mat-icon>
      <span>{{ error }}</span>
    </div>
  </div>

  <div class="accionModal">
    <div class="buttons" *ngIf="!enviado">
      <button mat-raised-button class="button cancelar" [mat-dialog-close]="false">Cancelar</button>
      <button
        mat-raised-button
        class="button enviar"
        (click)="enviar()"
        [disabled]="enviando"
      >
        {{ enviando ? "Enviando..." : "Enviar" }}
      </button>
    </div>
    <div class="buttons" *ngIf="enviado">
      <button mat-raised-button class="button enviar" [mat-dialog-close]="true">Aceptar</button>
    </div>
  </div>
</div>
